import { Blob, File as ConsigliFile } from '@consigli/types';
import { useCallback } from 'react';

import { downloadFile } from './utils';

interface UseDownloadDocumentProps {
  handleDownloadClick: (blob: Blob) => Promise<void>;
}

export const useDownloadDocument = ({ handleDownloadClick }: UseDownloadDocumentProps) => {
  const handleDownload = useCallback(
    (item: Blob | ConsigliFile) => {
      if ('name' in item) {
        handleDownloadClick(item);
      } else if ('filename' in item) {
        try {
          downloadFile(item as ConsigliFile);
        } catch (error) {
          console.error('Error downloading file:', error);
        }
      }
    },
    [handleDownloadClick],
  );

  return {
    handleDownload,
  };
};
